module.exports = __webpack_public_path__ + "static/media/d1.50cb6661.png";